module.exports = __webpack_public_path__ + "static/media/send-message-icon.ea1d9188.svg";